import { LegalPageLayout } from "./LegalPageLayout";

export default function Privacy() {
  return (
    <LegalPageLayout title="Politique de Confidentialité">
      <p><em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em></p>

      <h2>1. Introduction</h2>
      <p>
        Libaddict s'engage à protéger la vie privée de ses utilisateurs. 
        Cette politique décrit comment nous collectons, utilisons et protégeons 
        vos données personnelles conformément au Règlement Général sur la Protection 
        des Données (RGPD) et à la loi Informatique et Libertés.
      </p>

      <h2>2. Données collectées</h2>
      <h3>2.1 Données d'identification</h3>
      <ul>
        <li>Email</li>
        <li>Pseudo (facultatif)</li>
        <li>Téléphone (facultatif)</li>
      </ul>

      <h3>2.2 Données des praticiens</h3>
      <ul>
        <li>Numéro RPPS/Adeli</li>
        <li>Spécialités médicales</li>
        <li>Documents professionnels (justificatifs, diplômes)</li>
      </ul>

      <h3>2.3 Données de navigation</h3>
      <ul>
        <li>Cookies techniques et de performance</li>
        <li>Logs de connexion</li>
        <li>Adresse IP (anonymisée)</li>
      </ul>

      <h2>3. Finalité du traitement</h2>
      <p>Les données collectées servent à :</p>
      <ul>
        <li>Permettre la création et la gestion de compte utilisateur</li>
        <li>Faciliter la mise en relation entre patients et praticiens</li>
        <li>Garantir la sécurité du site et prévenir les abus</li>
        <li>Améliorer le fonctionnement du service</li>
      </ul>

      <h2>4. Base légale</h2>
      <p>Le traitement repose sur :</p>
      <ul>
        <li>L'exécution d'un contrat (accès au service)</li>
        <li>Le consentement de l'utilisateur</li>
        <li>L'intérêt légitime de Libaddict à assurer la sécurité de son site</li>
      </ul>

      <h2>5. Conservation des données</h2>
      <p>
        Les données sont conservées tant que le compte utilisateur reste actif, 
        et jusqu'à 3 ans après la dernière activité, avant suppression automatique.
      </p>

      <h2>6. Sécurité et hébergement</h2>
      <p>
        Les données sont hébergées sur Supabase, dont les serveurs 
        sont situés au sein de l'Union Européenne et respectent le RGPD. 
        Des mesures techniques (chiffrement, journalisation, pare-feu) et 
        organisationnelles garantissent la confidentialité et l'intégrité des informations.
      </p>

      <h2>7. Droits des utilisateurs</h2>
      <p>Conformément au RGPD, vous disposez de :</p>
      <ul>
        <li>Droit d'accès et de rectification</li>
        <li>Droit d'opposition et de suppression</li>
        <li>Droit à la portabilité des données</li>
        <li>Droit à la limitation du traitement</li>
      </ul>
      <p>
        Pour exercer ces droits, contactez : <a href="mailto:contact@libaddict.com">contact@libaddict.com</a>
      </p>

      <h2>8. Sous-traitants</h2>
      <p>
        Les prestataires techniques (Supabase, Ionos) agissent 
        comme sous-traitants de données et sont soumis à des clauses contractuelles 
        conformes au RGPD.
      </p>

      <h2>9. Contact DPO</h2>
      <p>
        Pour toute demande relative à vos données personnelles :<br />
        Délégué à la Protection des Données : <a href="mailto:contact@libaddict.com">contact@libaddict.com</a>
      </p>
    </LegalPageLayout>
  );
}
